import React, { createContext, ReactNode, useContext, createElement } from 'react';
import type { TAppContext } from 'src/types';
import { Notification } from 'elmo-elements';
import { Modals } from 'src/components/Modals';
import { useAppContext, defaultState } from './hooks';

type TProps = {
    children: ReactNode;
};

export const AppContext = createContext<TAppContext>({
    values: defaultState,
    actions: {
        handleDateRangeChange: () => {},
        handleLocationChange: () => {},
        handleSubLocationChange: () => {},
        handleViewChange: () => {},
        handleCallNotification: () => {},
        handleCallModal: () => {},
        handleCloseModal: () => {},
        handleSetUsers: () => {},
    },
});

export const useAppState = () => useContext(AppContext);

export const AppProvider = ({ children }: TProps) => {
    const context = useAppContext();
    return (
        <AppContext.Provider value={context}>
            {children}
            {createElement(Notification, context.values.notification ?? {})}
            {createElement(Modals, { modalData: context.values.modalData })}
        </AppContext.Provider>
    );
};
